import { AccessReviewViewType } from 'pbts/c1/api/accessreview/v1/accessreview'

export const AccessReviewViewOptions = [
    {
        label: 'None',
        value: AccessReviewViewType.UNSPECIFIED,
    },
    {
        label: 'By application',
        value: AccessReviewViewType.BY_APP,
    },
    {
        label: 'By user',
        value: AccessReviewViewType.BY_USER,
    },
    {
        label: 'Unstructured',
        value: AccessReviewViewType.UNSTRUCTURED,
    },
]

export { ReviewStylePickerBody } from 'components/pages/my_tasks/access_reviews/common/review-style-picker/ReviewStylePickerBody'
export { getAccessReviewStyleSelection } from 'components/pages/my_tasks/access_reviews/common/review-style-picker/review-style-local-storage'
export { ReviewStylePickerModal } from 'components/pages/my_tasks/access_reviews/common/review-style-picker/ReviewStylePickerModal'
